<template>
  <div>
    <div class="ordertoppage">
      <img class="ordericonimg" src="/static/newprojecticon/yizhifu.png" />
      <div class="paysuccess">{{orderdetail.status}}</div>
    </div>
    <div class="orderdetaillist">
      <div class="orderdetailbox">
        <div class="orderdetailname">实付金额</div>
        <div class="orderdetailvalue" style="color: #029DFF;">￥{{orderdetail.settlement_amount}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">支付方式</div>
        <div class="orderdetailvalue">微信</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单编号</div>
        <div class="orderdetailvalue">{{orderdetail.recover_no}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单时间</div>
        <div class="orderdetailvalue">{{orderdetail.created_at}}</div>
      </div>
      <div class="orderreturnindex" @click="pageToIndex">返回首页</div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        recover_no:"",
        orderdetail:{},
      }
    },
    created() {
      if (this.$route.query.recover_no) {
        this.recover_no = this.$route.query.recover_no
      }
      this.request("recoverperview", {
        recover_no: this.recover_no
      })
    },
    methods: {
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //订单信息
          case 'recoverperview':
            httper.get('order/recover-preview', requestData, res => {
              if (res.code == 0) {
                this.orderdetail = res.data
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
          // 获取订单详情
          case 'getDetail':
            httper.get('order/get-by-order-no', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                let dingmine = Number(res.data.created_at2) + 1800
                let nowtime = new Date();
                let nowmine = Number(nowtime.getTime() / 1000)
                let timechao = dingmine - nowmine > 0
                let timeqia = dingmine - nowmine
                let time = parseInt(timeqia % 60)
                let minutes = parseInt(timeqia / 60)
                this.list = res.data
                this.timechao = timechao

                if (res.data.order_status == 0 && timechao) {
                  //倒计时
                  let interval = setInterval(() => {
                    time--
                    if (time >= 10) {
                      that.currentTime = minutes + '分' + time + '秒'
                    }
                    if (time > 0 && time < 10) {
                      that.currentTime = minutes + '分' + '0' + time + '秒'
                    }
                    if (time <= 0) {
                      if (minutes > 0) {
                        minutes--;
                        time = 60;
                        that.currentTime = minutes + '分' + time + '秒'
                      } else {
                        clearInterval(interval);
                        that.currentTime = ''
                      }
                    }
                  }, 1000)
                }
              } else {
                this.$toast({
                  message: res.message || '系统错误',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style scoped="scoped">
  .ordertoppage {
    width: 100%;
    background-color: #FD8C00;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .ordericonimg {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }
.paysuccess{
  font-size: 21px;
  color: #FFFFFF;
  margin-bottom: 10px;
  font-weight: bold;
}
  .ordericontext {
    font-size: 15px;
    font-weight: 400;
    color: #FFFFFF;
  }

  .orderdetaillist {
    width: calc(100% - 40px);
    margin: 20px;
    position: absolute;
    top: 110px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);

  }

  .orderdetailbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .orderreturnindex {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.5);
  }

  .orderdetailname {
    width: 50%;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
  }

  .orderdetailvalue {
    font-size: 14px;
    width: 50%;
    text-align: end;
  }
</style>



// WEBPACK FOOTER //
// src/pages/payment/paysuccess.vue